export default __webpack_public_path__ + "static/media/demonicrenewal.d3201368.png";